import React, { createContext, useReducer, useContext, useState } from 'react';

const AuthContext = createContext(undefined);

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { isAuthenticated: true };
        case 'LOGOUT':
            return { isAuthenticated: false };
        default:
            return state;
    }
};

const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, { isAuthenticated: false });
    const [token, setToken] = useState('');

    return (
        <AuthContext.Provider value={{ state, dispatch,  token, setToken }}>
            {children}
        </AuthContext.Provider>
    );
};

const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth debe usarse dentro de un AuthProvider');
    }
    return context;
};

export { AuthContext, AuthProvider, useAuth };
